import * as React from 'react';
import styled from 'styled-components';
import {Container as LastTransactionsContainer, Header, Title, ButtonShowAll} from './LastTransactions';
import ItemCard, {ItemCardType} from './ItemCard';
import {CourseObject} from 'api/course';
import {WebinarObject} from 'api/webinar/types';
import {getImageByPreview} from 'api/library';
import moment from 'moment';
import {getWebinars} from 'api/webinar/requests';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {navigateTo} from "helpers/navigate-to";
import useLoading from 'hooks/use-loading';

const Container = styled(LastTransactionsContainer)`
  max-width: none;
  border: none;
  background-color: transparent;
  
  ${Header} {
    padding: 0;
    margin-bottom: 14px;
    background-color: transparent;
  }
`;

export const Content = styled.div`
  display: grid;
  gap: 10px;
`;

/**
 * The function render last courses block
 * @constructor
 */
export default function UpcomingWebinars() {
  const {data, fetch} = useLoading<WebinarObject[]>();

  React.useEffect(() => {
    fetch(() => new Promise((resolve) => (
      getWebinars({
        my: '1',
      }).then((response) => {
        validateResponse(response);

        if (response && !isError(response)) {
          resolve(response);
        }
      })
    )));
  }, []);

  /**
   * The function render content
   * @constructor
   */
  function renderContent() {
    const webinars: WebinarObject[] = data || [];

    const result: WebinarObject[] = [];

    const webinar1 = webinars.length && webinars[webinars.length - 1];
    const webinar2 = webinars.length && webinars[webinars.length - 2];

    webinar1 && result.push(webinar1);
    webinar2 && result.push(webinar2);

    return result.map(renderItem);
  }

  /**
   * The function render content item
   * @param {CourseObject} webinar
   * @constructor
   */
  function renderItem(webinar: WebinarObject) {
    const image = getImageByPreview(webinar.preview);
    return (
      <ItemCard
        key={webinar.id}
        type={ItemCardType.Webinar}
        title={webinar.title}
        info={moment(webinar.date).format('DD.MM.YYYY в HH:MM')}
        imgSrc={image}
        onBtnClick={() => window.open(webinar.link, '_blank')}
      />
    );
  }

  /**
   * The navigation handler function
   * @constructor
   */
  function navigateHandler() {
    navigateTo('webinars')
  }

  return data?.length && (
    <Container>
      <Header>
        <Title>Предстоящие трансляции</Title>
        <ButtonShowAll onClick={navigateHandler}>Все</ButtonShowAll>
      </Header>
      <Content>
        {renderContent()}
      </Content>
    </Container>
  ) || null;
}
